export enum PermissionLevel {
    VIEW = 'view',
    READ = 'read',
    EDIT = 'edit',
}

// Map permission levels to numerical values for comparison
export const PermissionPoint = {
    [PermissionLevel.VIEW]: 1,
    [PermissionLevel.READ]: 2,
    [PermissionLevel.EDIT]: 3,
} as const

// Map actions to required permission levels
export const ActionPermissions = {
    view: PermissionPoint[PermissionLevel.VIEW], // View/Preview (e.g., GetFile, GetThumbnail)
    download: PermissionPoint[PermissionLevel.READ], // Download (e.g., DownloadFile, DownloadFolder)
    modify: PermissionPoint[PermissionLevel.EDIT], // Modify (e.g., RenameObject, DuplicateObject)
    delete: PermissionPoint[PermissionLevel.EDIT], // Delete (e.g., DeleteObject)
    share: PermissionPoint[PermissionLevel.EDIT], // CreateShareLink (optional)
} as const

// Check if a permission level allows an action
export function checkPermission(
    permission: PermissionLevel,
    action: keyof typeof ActionPermissions
): boolean {
    const userLevel = PermissionPoint[permission]
    if (!userLevel) {
        console.error(`Invalid permission level: ${permission}`)
        return false
    }

    const requiredLevel = ActionPermissions[action]
    if (!requiredLevel) {
        console.error(`Unknown action: ${action}`)
        return false
    }

    return userLevel >= requiredLevel
}
